export default [
	{
		path: "/*",
		ssr: false,
		component: "Errors",
	},
];
